// SUNDAY FIRST: schedule-expansion.ts indexes this with a 0-is-Sunday number.
export const WEEKDAY_CODES = ["SU", "MO", "TU", "WE", "TH", "FR", "SA"] as const;
export type Weekday = (typeof WEEKDAY_CODES)[number];

export type ScheduleRecurrence =
  | { freq: "daily" }
  | { freq: "weekly"; days: Weekday[]; everyWeeks?: number }
  | { freq: "interval"; everyDays: number }
  | { freq: "monthly"; nth: 1 | 2 | 3 | 4 | 5 | -1; weekday: Weekday; everyMonths: number }
  | { freq: "monthly_date"; dayOfMonth: number; everyMonths: number };

// They tile the whole day so every scheduled time falls in exactly one.
export const DEFAULT_MED_PASS_WINDOWS = [
  { name: "Morning", startTime: "00:00", endTime: "10:59", defaultDoseTime: "08:00" },
  { name: "Afternoon", startTime: "11:00", endTime: "15:29", defaultDoseTime: "14:00" },
  { name: "Evening", startTime: "15:30", endTime: "18:59", defaultDoseTime: "17:00" },
  { name: "Night", startTime: "19:00", endTime: "23:59", defaultDoseTime: "20:00" },
] as const;

export const DEFAULT_EXCEPTION_REASONS = [
  { name: "Refused", requiresNote: false },
  { name: "Out of Facility / LOA", requiresNote: false },
  { name: "Hospitalized", requiresNote: false },
  { name: "Held (clinical)", requiresNote: true },
  { name: "Medication not available", requiresNote: false },
  { name: "Self-administered", requiresNote: false },
  { name: "Dropped / Wasted", requiresNote: true },
  { name: "Sleeping / Unavailable", requiresNote: false },
  { name: "Other", requiresNote: true },
] as const;
